import {Grid, Tab, Tabs, Typography} from "@mui/material";
import React, {useState} from "react";
import AssignRole from "./AssignRole";
import UserList from "./UserList";
import UserOnboarding from "./UserOnboarding";

const AdminAccess = () => {
  const [value, setValue] = useState("addUser");

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Typography variant="h4" gutterBottom component="div">
        Admin panel
      </Typography>
      <Grid container spacing={2}>
        <Grid item>
          <Tabs
            value={value}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons={false}
          >
            <Tab value={"addUser"} label="Add New User" />
            <Tab value={"userList"} label="User List" />
            <Tab value={"assignedRole"} label="Assigned Role List" />
          </Tabs>
        </Grid>
        <Grid item lg={12}>
          {value === "addUser" && <UserOnboarding />}
          {value === "userList" && <UserList />}
          {value === "assignedRole" && <AssignRole />}
        </Grid>
      </Grid>
    </>
  );
};

export default AdminAccess;
